export default "__VITE_ASSET__fee8e0a7__"